import "./index.scss";

export const SwitchInput = ({ checked, onChange }) => {
  return (
    <div
      className="switch-container uk-flex uk-flex-middle"
    >
      <div className="icon-sun">
        <div className="sun-burst" />
      </div>
      <label className="uk-switch" htmlFor="theme-switch">
        <input
          type="checkbox"
          id="theme-switch"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <div className="uk-switch-slider uk-border-pill" />
      </label>
      <div className="moon"></div>
    </div>
  );
};
